import { useEffect, useState } from 'react';
import DashboardMenu from './DashboardMenu';
import { useNavigate } from 'react-router-dom';
import { GetTrackEmployeeWorkStatusUserService } from '../../services/ClientServices';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { ButtonOutlinedAutoWidth } from '../../components/button';

function LeaderBoardWorkStatus() {

  const today = dayjs(); // default today date

  const getRankIcon = (index) => {
    if (index === 0) return "🥇";
    if (index === 1) return "🥈";
    if (index === 2) return "🥉";
    return "";
  };

  const navigator = useNavigate();
  const [data, setdata] = useState([]);

  const [search, setsearch] = useState({
    from_date: today,
    from_date1: today.format("YYYY-MM-DD"),
    to_date: today,
    to_date1: today.format("YYYY-MM-DD"),
    user: ''
  });

  useEffect(() => {
    getData();

    const interval = setInterval(() => {
      getData();
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  async function getData() {
    const response = await GetTrackEmployeeWorkStatusUserService(
      search?.from_date1,
      search?.to_date1,
      search?.user
    );
    setdata(response?.data?.data);
  }

  function convertionRatio(d) {
    let result = ((d?.subscribed_user / d?.customerCount) * 100).toFixed(2);
    return Math.round(result) + '%';
  }

  async function applyFilter() {
    const response = await GetTrackEmployeeWorkStatusUserService(
      search?.from_date1,
      search?.to_date1,
      search?.user
    );
    setdata(response?.data?.data);
  }

  // ------------- DATE DISABLE LOGIC (31 DAYS) --------------

  const disableFromDate = (current) => {
    if (!search.to_date) return false;
    return (
      current > search.to_date.add(0, "day") ||
      current < search.to_date.subtract(31, "day")
    );
  };

  const disableToDate = (current) => {
    if (!search.from_date) return false;
    return (
      current < search.from_date.subtract(0, "day") ||
      current > search.from_date.add(31, "day")
    );
  };

  // ---------------------------------------------------------

  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>
      <div className='md:flex items-start'>
        <DashboardMenu />
        <div className='md:w-[90%] pl-5 pt-4'>

          <div className='md:flex items-center py-2 border-b justify-between'>
            <div className='flex flex-wrap items-center w-full justify-between'>
              <h6 className='font-[800] text-[13px]'>
               Day Wise Leader Board (See Your Points)
              </h6>

              <div className='flex mt-2 md:mt-0 items-center'>
                
                {/* FROM DATE */}
                <DatePicker
                  size='small'
                  style={{ fontSize: '11px' }}
                  placeholder='From Date'
                  className='text-[11px] py-[2.6px] w-28 border-slate-300 mr-2'
                  value={search.from_date}
                  disabledDate={disableFromDate}
                  onChange={(v, v1) => {
                    setsearch({
                      ...search,
                      from_date: v,
                      from_date1: v1
                    });
                  }}
                />

                {/* TO DATE */}
                <DatePicker
                  size='small'
                  style={{ fontSize: '11px' }}
                  placeholder='To Date'
                  className='text-[11px] py-[2.6px] w-28 border-slate-300 mr-2'
                  value={search.to_date}
                  disabledDate={disableToDate}
                  onChange={(v, v1) => {
                    setsearch({
                      ...search,
                      to_date: v,
                      to_date1: v1
                    });
                  }}
                />

                <div className='mr-2 mt-1 md:mt-0'>
                  <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
                </div>

              </div>
            </div>
          </div>

          {/* TABLE START */}
          <div className="w-full md:w-fit mt-2 overflow-x-auto border">

            <div className="flex bg-[#2a297e] w-fit text-white items-center">
              <h6 className="min-w-[50px] w-[50px] text-[12px] p-2 font-bold border-r">Sl No</h6>
              <h6 className="min-w-[100px] w-[100px] text-[12px] p-2 font-bold border-r">Image</h6>
              <h6 className="min-w-[200px] w-[200px] text-[12px] p-2 font-bold border-r">Name</h6>
              <h6 className="min-w-[150px] w-[150px] text-[12px] p-2 font-bold border-r">Subscribed User</h6>
              <h6 className="min-w-[150px] w-[150px] text-[12px] p-2 font-bold border-r">App Installed</h6>
              <h6 className="min-w-[150px] w-[150px] text-[12px] p-2 font-bold">Customer Assigned</h6>
            </div>

            {data?.map((d, i) => (
              <div
                key={i}
                className={`flex w-fit font-bold border-t ${
                  i === 0 ? "bg-yellow-100" :
                    i === 1 ? "bg-gray-100" :
                      i === 2 ? "bg-orange-100" : ""
                }`}
              >
                <h6 className="min-w-[50px] w-[50px] text-[12px] p-2 font-bold border-r flex items-center gap-1">
                  <span className='text-[25px]'>{getRankIcon(i)}</span> {i + 1}
                </h6>

                <h6 className="min-w-[100px] w-[100px] text-[12px] p-2 font-bold border-r">
                  {d?.user?.profile_photo && (
                    <img
                      className="w-full h-[50px] object-contain"
                      src={`${process.env.REACT_APP_AWS_IMAGE_URL}${d?.user?.profile_photo}`}
                    />
                  )}
                </h6>

                <h6 className="min-w-[200px] w-[200px] text-[12px] p-2 font-bold border-r flex items-center gap-1">
                  <span className='text-[25px]'>{
                    i === 0 ? "🏆" : i === 1 ? "🥈" : i === 2 ? "🥉" : ""
                  }</span>
                  {d?.user?.name}
                </h6>

                <h6 className="min-w-[150px] w-[150px] text-[12px] flex p-2 font-bold border-r">
                  {d?.subscribedCount}
                </h6>

                <h6 className="min-w-[150px] w-[150px] text-[12px] p-2 font-bold border-r">
                  {d?.customer_app_installed?.length}
                </h6>

                <h6 className="min-w-[150px] w-[150px] text-[12px] flex p-2 font-bold">
                  {d?.customer_assigned?.length}
                </h6>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}

export default LeaderBoardWorkStatus;
